import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

import { workOrdersListSearchSchema } from '&/features/work-orders/lib/work-orders-list-search';
import { WORK_ORDERS_LIST_PERMISSION, WORK_ORDERS_PATH } from '&/features/work-orders/paths';
import { requireModule } from '&/lib/module-gate';

export const Route = createFileRoute('/_authenticated/work-orders')({
  beforeLoad: ({ context }): void => {
    // Entitlement: a tenant without the Maintenance module (which owns this path in the registry) gets
    // the standard not-found. This covers client-side navigation only; the page is also gated for the
    // hard-refresh case. Permission is a separate gate and redirects instead (as the Maintenance
    // settings route does).
    requireModule(context.entitlement, WORK_ORDERS_PATH);
    if (context.permissions.isReady && !context.permissions.hasPermission(WORK_ORDERS_LIST_PERMISSION)) {
      throw redirect({ to: '/' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/work-orders/pages/work-orders-page')),
  staticData: { titleKey: 'workOrders' },
  // The list's tab / filters / search / page live in the URL (SWOOP-326) so a Back restores the list.
  // Every field is optional and coerced, so this never rejects.
  validateSearch: (search) => workOrdersListSearchSchema.parse(search),
});
